import {
  CheckboxGroup,
  Collapse,
  Flex,
  Grid,
  Group,
  Loader,
  TextInput,
  UnstyledButton,
} from "@mantine/core";
import { IconChevronDown, IconSearch } from "@tabler/icons-react";
import classes from "./SearchBar.module.css";
import { useEffect, useRef } from "react";

interface SearchBar {
  isLoading: boolean;
  resetPage(): boolean;
  changeTableState(): void;
  search: string;
  handleSearch(event: React.ChangeEvent<HTMLInputElement>): void;
  setShowFilterOptions: React.Dispatch<React.SetStateAction<boolean>>;
  showFilterOptions: boolean;
  selectedFilters: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<string[]>>;
  checkboxesFilter: JSX.Element[];
}

// eslint-disable-next-line  @typescript-eslint/no-redeclare
export const SearchBar: React.FC<SearchBar> = ({
  isLoading,
  resetPage,
  changeTableState,
  search,
  handleSearch,
  setShowFilterOptions,
  showFilterOptions,
  selectedFilters,
  setSelectedFilters,
  checkboxesFilter,
}) => {

  function loading() {
    resetPage();
    changeTableState();
  }

  const searchPrev = useRef("");
  const selectedFiltersPrev = useRef([""]);

  function arrDifferent(arr1: string[], arr2: string[]) {
    let isDifferent = false;

    if (arr1.length !== arr2.length) return !isDifferent;

    arr1.forEach((row) => {
      let noMatch = true;
      arr2.forEach((row2) => {
        if (row === row2) {
          noMatch = false;
          return;
        }
      });
      if (noMatch) {
        isDifferent = true;
        return;
      }
    });
    return isDifferent;
  }

  //Debounce for searching
  useEffect(() => {
    if (selectedFilters.length === 0 && search === "") {
      searchPrev.current = "";
      selectedFiltersPrev.current = [];
      return;
    }
    // console.log("here");
    // console.log(selectedFilters);

    // console.log("prev is");
    // console.log(selectedFiltersPrev.current);

    if (
      searchPrev.current === search &&
      !arrDifferent(selectedFilters, selectedFiltersPrev.current)
    )
      return;

    if (selectedFilters.length === 0) {
      if (arrDifferent(selectedFilters, selectedFiltersPrev.current)) {
        if (!resetPage()) changeTableState();
        selectedFiltersPrev.current = [];
      }

      return;
    }

    searchPrev.current = search;
    selectedFiltersPrev.current = selectedFilters;
    // console.log("prev is");
    // console.log(selectedFiltersPrev.current);

    const debounceTimeMs = 1000;
    const debounceSearch = setTimeout(loading, debounceTimeMs);
    return () => {
      clearTimeout(debounceSearch);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, JSON.stringify(selectedFilters)]);

  return (
    <Grid>
      <Grid.Col span={12}>
        <Flex align="center" gap="10px">
          <TextInput
            className={classes.searchbar}
            placeholder="Search"
            rightSection={
              <IconSearch
                style={{ width: "16px", height: "16px" }}
                stroke={1.5}
              />
            }
            value={search}
            onChange={handleSearch}
            style={{ width: "200px" }}
          />
          <UnstyledButton
            color="transparent"
            style={{
              height: "100%",
              position: "relative",
              marginTop: "30px",
            }}
            onClick={() => setShowFilterOptions((prevState) => !prevState)}
          >
            <IconChevronDown
              style={{ position: "absolute", bottom: "6px" }}
              stroke={1.5}
              color="blueviolet"
            />
          </UnstyledButton>
          {isLoading ? (
            <Loader style={{ marginLeft: "30px" }} color="blueviolet" />
          ) : (
            <></>
          )}
        </Flex>
      </Grid.Col>
      <Grid.Col
        span={12}
        style={{ paddingLeft: "30px", paddingBottom: "20px" }}
      >
        <Collapse in={showFilterOptions}>
          <CheckboxGroup
            defaultValue={[]}
            label="Filter Options"
            description="Select types to filter by"
            value={selectedFilters}
            onChange={setSelectedFilters}
          >
            <Group className={classes.checkbox}>{checkboxesFilter}</Group>
          </CheckboxGroup>
        </Collapse>
      </Grid.Col>
    </Grid>
  );
};
